<template>
    <ValidationObserver ref="validationObserver" slim>
        <div class="forms-feature__form-wrapper">
            <div class="forms-feature__field-block">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EnergySystems.ProductsTitle']}}</div>
                <CheckboxList :label="Strings['Forms.EnergySystems.Products']"
                              :options="Enums['EnergyProducts']"
                              v-model="wantedProducts"
                              display="block"
                              rules="required" />
                <small style="display: block; margin-top: 2.5rem">{{Strings['Forms.EnergySystems.ProductsFootnote']}}</small>
            </div>

            <div class="forms-feature__field-block" v-if="!IsClientKnown">
                <div class="forms-feature__field-block-title">{{Strings['Global.Address.ContactAddress']}}</div>
                <Address />
            </div>

            <!-- field group heating: -->
            <div class="forms-feature__field-block" v-if="wantedProducts.includes('HeatPump') || wantedProducts.includes('OilHeating') || wantedProducts.includes('PelletHeating')">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EnergySystems.GroupTitleHeating']}}</div>
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="heatingCurrentSystem"
                                     :label="Strings['Forms.EnergySystems.CurrentHeatingSystem']"
                                     rules="required"
                                     :options="heatingSystemsOptions" />
                </div>
                <div class="forms-feature__field-row" v-if="heatingCurrentSystem">
                    <InputWithLabel :label="heatingUsageLabel"
                                    type="number"
                                    v-model="heatingUsage"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:0|max_value:500000" />
                </div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.EnergySystems.InstallationYearHeatingSystem']"
                                    type="number"
                                    v-model="heatingCurrentSystemInstallationYear"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:1900|max_value:2050" />
                </div>
            </div>

            <!-- field group HeatPumpBoiler: -->
            <div class="forms-feature__field-block" v-if="wantedProducts.includes('HeatPumpBoiler')">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EnergySystems.GroupTitleHeatPumpBoiler']}}</div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.EnergySystems.InstallationYearBoiler']"
                                    type="number"
                                    v-model="boilerInstallationYear"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:1900|max_value:2050" />
                </div>                
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="boilerCurrentSize"
                                     :label="Strings['Forms.EnergySystems.CurrentBoilerSize']"
                                     rules="required"
                                     :options="boilerSizeOptions" />
                </div>
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="boilerDesiredSize"
                                     :label="Strings['Forms.EnergySystems.DesiredBoilerSize']"
                                     rules="required"
                                     :options="boilerSizeOptions" />
                </div>
            </div>

            <!-- field group BlowerReplacement: -->
            <div class="forms-feature__field-block" v-if="wantedProducts.includes('BlowerReplacement')">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EnergySystems.GroupTitleBlower']}}</div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.EnergySystems.BlowerUsage']"
                                    type="number"
                                    v-model="blowerUsage"
                                    :postfix="Strings['Shop.UnitsLiter']"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:0|max_value:200000" />
                </div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.EnergySystems.InstallationYearBlower']"
                                    type="number"
                                    v-model="blowerInstallationYear"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:1900|max_value:2050" />
                </div>
            </div>

            <!-- field group Photovoltaik: -->
            <div class="forms-feature__field-block" v-if="wantedProducts.includes('Photovoltaik')">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EnergySystems.GroupTitlePhoto']}}</div>
                <div class="forms-feature__field-row">
                    <RadiobuttonList :label="Strings['Forms.EnergySystems.PhotoPowerSaver']"
                                     :options="yesNoOptions"
                                     v-model="photoPowerSaver"
                                     rules="required" />
                </div>
            </div>

            <div class="forms-feature__field-block">
                <div class="forms-feature__field-row">
                    <Comments />
                </div>
            </div>

            <div class="forms-feature__field-block forms-feature__field-block--no-separator">
                <div class="forms-feature__field-row">
                    <DSE v-model="dseAccepted" />
                </div>
            </div>

            <ServerErrorMessageList />

            <div class="migrol-form__buttons">
                <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Forms.Submit']" @buttonClick="submitForm" cssclass="migrol-form__button--green" />
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import $ from 'jQuery';
    import Address from '../_common/Address';
    import Comments from '../_common/Comments';
    import ServerErrorMessageList from '../_common/ServerErrorMessageList'
    import { ValidationObserver } from 'VeeValidate'
    import { doValidation, getEnumOptions } from '@/utils/utils'

    export default {
        data() {
            return {
                yesNoOptions: [
                    { text: this.$store.state.Strings['Forms.OptionYes'], value: 'true' },
                    { text: this.$store.state.Strings['Forms.OptionNo'], value: 'false' }
                ]
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Enums',
                'IsClientKnown'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),
            dseAccepted: {
                get() { return this.$store.state.dseAccepted; },
                set(val) { this.$store.commit('setDseAccepted', val); }
            },
            wantedProducts: {
                get() { return this.$store.state.energySystems.wantedProducts; },
                set(val) { this.$store.commit('energySystems/setWantedProducts', val); }
            },
            // W�rmepumpe / �lheizung / Pelletheizung
            heatingCurrentSystem: {
                get() { return this.$store.state.energySystems.heatingCurrentSystem; },
                set(val) { this.$store.commit('energySystems/setHeatingCurrentSystem', val); }
            },
            heatingUsage: {
                get() { return this.$store.state.energySystems.heatingUsage; },
                set(val) { this.$store.commit('energySystems/setHeatingUsage', val); }
            },
            heatingUsageLabel: {
                get() {
                    switch (this.heatingCurrentSystem) {
                        case 'HeatPump':
                        case 'Electro':
                        case 'District':
                            return this.$store.state.Strings['Forms.EnergySystems.UsageElectricity'];
                        case 'Pellets':
                            return this.$store.state.Strings['Forms.EnergySystems.UsagePellets'];
                        case 'Wood':
                            return this.$store.state.Strings['Forms.EnergySystems.UsagePellets'];
                        case 'Gas':
                            return this.$store.state.Strings['Forms.EnergySystems.UsageGas'];
                        case 'Oil':
                            return this.$store.state.Strings['Forms.EnergySystems.UsageOil'];
                        case 'Other':
                        default:
                            return this.$store.state.Strings['Forms.EnergySystems.UsageGeneric'];
                    }
                }
            },
            heatingCurrentSystemInstallationYear: {
                get() { return this.$store.state.energySystems.heatingCurrentSystemInstallationYear; },
                set(val) { this.$store.commit('energySystems/setHeatingCurrentSystemInstallationYear', val); }
            },
            //W�rmepumpen-Boiler
            boilerInstallationYear: {
                get() { return this.$store.state.energySystems.boilerInstallationYear; },
                set(val) { this.$store.commit('energySystems/setBoilerInstallationYear', val); }
            },
            boilerCurrentSize: {
                get() { return this.$store.state.energySystems.boilerCurrentSize; },
                set(val) { this.$store.commit('energySystems/setBoilerCurrentSize', val); }
            },
            boilerDesiredSize: {
                get() { return this.$store.state.energySystems.boilerDesiredSize; },
                set(val) { this.$store.commit('energySystems/setBoilerDesiredSize', val); }
            },
            //Brennerersatz
            blowerUsage: {
                get() { return this.$store.state.energySystems.blowerUsage; },
                set(val) { this.$store.commit('energySystems/setBlowerUsage', val); }
            },
            blowerInstallationYear: {
                get() { return this.$store.state.energySystems.blowerInstallationYear; },
                set(val) { this.$store.commit('energySystems/setBlowerInstallationYear', val); }
            },
            //Photovoltaikanlage
            photoPowerSaver: {
                get() { return this.$store.state.energySystems.photoPowerSaver; },
                set(val) { this.$store.commit('energySystems/setPhotoPowerSaver', val); }
            },

            boilerSizeOptions() {
                return getEnumOptions(this.Enums["BoilerSizes"]);
            },
            heatingSystemsOptions() {
                return getEnumOptions(this.Enums["CurrentHeatingSystems"]);
            }
        },
        methods: {
            ...mapActions([
                'TriggerGoal'
            ]),
            submitForm() {
                let formData = { ...this.$store.getters['baseData'], ...this.$store.state.energySystems };
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.$store.commit('clearServerErrormessages');
                    vm.$store.commit('increasePendingAjaxCalls');
                    $.post({
                        url: '/migrolapi/' + window.CONFIG.language + '/forms/SubmitEnergySystemsForm',
                        data: JSON.stringify(formData),
                        contentType: 'application/json'
                    })
                        .done((response) => {
                            if (!response.Success)
                                vm.manageError(response);
                            else {
                                this.$router.push('/thanks').catch(() => { });
                                vm.TriggerGoal();
                            }
                        })
                        .fail(() => {
                            vm.manageError(null);
                        })
                        .always(function () {
                            vm.$store.commit('decreasePendingAjaxCalls');
                        });
                });
            },
            manageError(response) {
                if (!response || !response.ErrorMessages || response.ErrorMessages.length == 0)
                    this.$store.commit('addServerErrormessages', [{ TextKey: 'Shop.Errors.GenericError' }]);
                else
                    this.$store.commit('addServerErrormessages', response.ErrorMessages);
            }
        },
        components: {
            Address,
            ValidationObserver,
            Comments,
            ServerErrorMessageList
        }
    };
</script>